import HeaderProfile from './HeaderProfile'

export default HeaderProfile
